import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaNodeJs } from "react-icons/fa";
import { TbBrandNextjs } from "react-icons/tb";
import {
  SiJavascript,
  SiMui,
  SiReact,
  SiTailwindcss,
  SiMongodb,
  SiMysql,
  SiTypescript,
  SiGithub,
  SiExpress,
  SiSpringboot,
  SiRedux,
  SiJunit5,
  SiJest,
  SiSelenium,
  SiCodio
} from "react-icons/si";
import { FaJava } from "react-icons/fa";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
    experience: "ADVANCE",
  },
  {
    _id: 2,
    name: "CSS",
    icon: BsFiletypeCss,
    experience: "INTERMEDIATE",
  },
  {
    _id: 3,
    name: "Tailwind ",
    icon: SiTailwindcss,
    experience: "INTERMEDIATE",
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
    experience: "INTERMEDIATE",
  },
  {
    _id: 5,
    name: "TypeScript",
    icon: SiTypescript,
    experience: "BASIC",
  },
  {
    _id: 6,
    name: "React.js",
    icon: SiReact,
    experience: "INTERMEDIATE",
  },
  {
    _id: 7,
    name: "Next.js",
    icon: TbBrandNextjs,
    experience: "BASIC",
  },
  {
    _id: 8,
    name: "React MUI",
    icon: SiMui,
    experience: "INTERMEDIATE",
  },
  {
    _id: 9,
    name: "Bootstrap ",
    icon: BsBootstrap,
    experience: "INTERMEDIATE",
  },

  {
    _id: 10,
    name: "Node.js",
    icon: FaNodeJs,
    experience: "INTERMEDIATE",
  },
  {
    _id: 11,
    name: "Express.js",
    icon: SiExpress,
    experience: "INTERMEDIATE",
  },

  {
    _id: 12,
    name: "Mongodb ",
    icon: SiMongodb,
    experience: "INTERMEDIATE",
  },
  {
    _id: 13,
    name: "SQL ",
    icon: SiMysql,
    experience: "INTERMEDIATE",
  },
    {
    _id: 14,
    name: "C",
    icon: SiCodio,
    experience: "INTERMEDIATE",
  },
  {
    _id: 15,
    name: "Java",
    icon: FaJava,
    experience: "INTERMEDIATE",
  },
  {
    _id: 16,
    name: "SpringBoot",
    icon: SiSpringboot,
    experience: "INTERMEDIATE",
  },
  {
    _id: 17,
    name: "Redux",
    icon: SiRedux,
    experience: "INTERMEDIATE",
  },
  {
    _id: 18,
    name: "JUnit",
    icon: SiJunit5,
    experience: "INTERMEDIATE",
  },
  {
    _id: 19,
    name: "Jest",
    icon: SiJest,
    experience: "INTERMEDIATE",
  },
  {
    _id: 20,
    name: "Selenium",
    icon: SiSelenium,
    experience: "INTERMEDIATE",
  },
  {
    _id: 21,
    name: "Git",
    icon: SiGithub,
    experience: "INTERMEDIATE",
  },
];
